import { Result } from '../../../common-models/Result';
import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { ReportService } from '../ReportService';
import { GenerateTransportOrderBaseReportInput } from './GenerateTransportOrderBaseReportInput';
import { GenerateTransportOrderBaseReportOutput } from './GenerateTransportOrderBaseReportOutput';

export class GenerateTransportOrderBaseReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handleCsvOrders = (input: GenerateTransportOrderBaseReportInput): Promise<Result<GenerateTransportOrderBaseReportOutput> | null> => {
    const promise = this.http.post<Result<GenerateTransportOrderBaseReportOutput>, GenerateTransportOrderBaseReportInput>(
      `${this.baseUrlSislogApi}/v2/report-orders-in-transport/csv-orders`,
      input
    );
    return promise;
  }

}